import { AccessReportsServiceArea } from "@app/access-reports/shared/accessReportsServiceArea";
import { AccessReportsWizardOption } from "@app/access-reports/shared/accessReportsWizardOption";

class AccessReportsWizardEmployeeCountPage {
  columns: AccessReportsWizardOption[];
  employeeCount: boolean;
  employeeGroupIds: number[];
  filteredWithinServiceArea: AccessReportsWizardOption;
  hasServiceArea: boolean;
  id: number;
  serviceArea: AccessReportsServiceArea;
  summarizeBy: AccessReportsWizardOption;

  constructor(employeeCount: boolean, id: number) {
    this.columns = [];
    this.employeeCount = employeeCount;
    this.employeeGroupIds = [];
    this.filteredWithinServiceArea = null;
    this.hasServiceArea = false;
    this.id = id;
    this.serviceArea = null;
    this.summarizeBy = null;
  }
}
  
export { AccessReportsWizardEmployeeCountPage };
